import { cn } from "@/components/podkit/lib/cn";
import type { PropsWithChildren } from "react";

export function StepHeadline({ children, className }: PropsWithChildren<{ className?: string }>) {
    return <h1 className={cn("text-center text-2xl font-medium text-content-primary", className)}>{children}</h1>;
}
